import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const updateTrainedTask = createAsyncThunk(
  "Staff/updateTrainedTask",
  async (data, thunkAPI) => {
    const { handleSuccess, handleError } = data;
    try {
      const resp = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/users/staff-management/trained-task/${data.user_id}`,
        data.schema,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (resp.data && handleSuccess) {
        handleSuccess();
      }
      return resp.data;
    } catch (error) {
      if (error.response) {
        if (handleError) {
          handleError(
            error.response.data.errorMessage || error.response.data.message
          );
        }
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        if (handleError) {
          handleError(error.message);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
